/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cv_Extract_Form_Achievements_LabelInputs */

const en_cv_extract_form_achievements_label = /** @type {(inputs: Cv_Extract_Form_Achievements_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Achievements`)
};

const de_cv_extract_form_achievements_label = /** @type {(inputs: Cv_Extract_Form_Achievements_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leistungen`)
};

/**
* | output |
* | --- |
* | "Achievements" |
*
* @param {Cv_Extract_Form_Achievements_LabelInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const cv_extract_form_achievements_label = /** @type {((inputs?: Cv_Extract_Form_Achievements_LabelInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cv_Extract_Form_Achievements_LabelInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_cv_extract_form_achievements_label(inputs)
	return en_cv_extract_form_achievements_label(inputs)
});